const STORE_DIAGNOSIS_BASEDATA = 'STORE_DIAGNOSIS_BASEDATA'
const STORE_SUBJ_ID = 'STORE_SUBJ_ID'
const STORE_ROUTING_AFTER_VALIDATION = 'STORE_ROUTING_AFTER_VALIDATION'
const DELETE_ROUTING_AFTER_VALIDATION = 'DELETE_ROUTING_AFTER_VALIDATION'

const state = {
  diagnosisBaseData: '{}',
  routingAfterReportValidation: '{}',
  actualSubjId: '{}',
  formsMetadata: [
    {
      title: 'Erstdiagnose',
      navName: 'Erstdiagnose',
      key: 'register'
    },
    {
      title: 'Untersuchung',
      navName: 'Untersuchung',
      key: 'progress',
      parent: 'progress'
    },
    {
      title: 'Operation',
      navName: 'Operation',
      key: 'operation',
      parent: 'operations'
    },
    {
      title: 'Strahlentherapie',
      navName: 'Strahlentherapie',
      key: 'radiationTherapy',
      parent: 'radiationtherapies'
    },
    {
      title: 'Systemische Therapie',
      navName: 'Systemische Therapie',
      key: 'systemicTherapy',
      parent: 'systemictherapies'
    },
    {
      title: 'Tumorkonferenz',
      navName: 'Tumorkonferenz',
      key: 'tumorConference',
      parent: 'tumorconferences'
    }
  ]
}

const mutations = {
  [STORE_DIAGNOSIS_BASEDATA] (state, data) {
    if (data.patientId) {
      let storedData = typeof state.diagnosisBaseData === 'string' ? JSON.parse(state.diagnosisBaseData) : state.diagnosisBaseData
      storedData[data.patientId] = data
      state.diagnosisBaseData = JSON.stringify(storedData)
    }
  },
  [STORE_SUBJ_ID] (state, data) {
    let storedData = typeof state.actualSubjId === 'string' ? JSON.parse(state.actualSubjId) : state.actualSubjId
    storedData[data.patient] = data.subjId
    state.actualSubjId = JSON.stringify(storedData)
  },
  [STORE_ROUTING_AFTER_VALIDATION] (state, data) {
    if (data.patientId) {
      let storedData = typeof state.routingAfterReportValidation === 'string' ? JSON.parse(state.routingAfterReportValidation) : state.routingAfterReportValidation
      storedData[data.patientId] = data
      state.routingAfterReportValidation = JSON.stringify(storedData)
    }
  },
  [DELETE_ROUTING_AFTER_VALIDATION] (state, data) {
    if (data) {
      let storedData = typeof state.routingAfterReportValidation === 'string' ? JSON.parse(state.routingAfterReportValidation) : state.routingAfterReportValidation
      delete storedData[data]
      state.routingAfterReportValidation = JSON.stringify(storedData)
    }
  }
}

const actions = {
  setDiagnosisBaseInformation ({ commit }, data) {
    commit(STORE_DIAGNOSIS_BASEDATA, data)
  },
  setActualSubjID ({ commit }, data) {
    commit(STORE_SUBJ_ID, data)
  },
  setRoutingAfterReportValidation ({ commit }, data) {
    commit(STORE_ROUTING_AFTER_VALIDATION, data)
  },
  deleteRoutingAfterReportValidation ({ commit }, data) {
    commit(DELETE_ROUTING_AFTER_VALIDATION, data)
  }
}

const getters = {
  getformsMetadata: state => state.formsMetadata,
  getActualSubjId: state => patient => {
    return typeof state.actualSubjId === 'string' ? JSON.parse(state.actualSubjId)[patient] : state.actualSubjId[patient]
  },
  diagnosisBaseData: state => patient => {
    return typeof state.diagnosisBaseData === 'string' ? JSON.parse(state.diagnosisBaseData)[patient] : state.diagnosisBaseData[patient]
  },
  routingAfterReportValidation: state => patient => {
    return typeof state.routingAfterReportValidation === 'string' ? JSON.parse(state.routingAfterReportValidation)[patient] : state.routingAfterReportValidation[patient]
  },
  routing: state => {
    return typeof state.routingAfterReportValidation === 'string' ? JSON.parse(state.routingAfterReportValidation) : state.routingAfterReportValidation
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
